/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgChatWarning = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.75 10.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-.258-5.84A.5.5 0 0 0 7.5 5v3.5l.008.09A.5.5 0 0 0 8.5 8.5V5l-.008-.09ZM8 2a6 6 0 0 0-5.27 8.872l-.71 2.49a.5.5 0 0 0 .638.612l2.338-.779A6 6 0 1 0 8 2ZM3 8a5 5 0 1 1 2.325 4.225.5.5 0 0 0-.426-.052l-1.658.553.51-1.781a.5.5 0 0 0-.052-.393A4.975 4.975 0 0 1 3 8Z"
    }));
export default SvgChatWarning;
